export default "__VITE_ASSET__0d5fcec6__"